import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';

/**
 * O índice do item em edição nasce aqui, uma única vez, e alimenta os dois
 * lados: o lápis de cada card (na View) e o acordeão do `object_list` (no
 * Data). Duplicar esse estado dentro da View é o bug que o bloco
 * `homeBannerPortal` tem hoje — lá o clique na canvas não abre o item certo.
 */
const Edit = (props) => {
  const { block, data, onSelectBlock, selected } = props;
  const [activeItem, setActiveItem] = React.useState(-1);

  const handleEditItem = React.useCallback(
    (index: number) => {
      // Sem selecionar o bloco, o `SidebarPortal` nem monta o formulário.
      onSelectBlock?.(block);
      setActiveItem(index);
    },
    [block, onSelectBlock],
  );

  return (
    <>
      <View {...props} data={data} onEditItem={handleEditItem} />

      <SidebarPortal selected={selected}>
        <Data
          {...props}
          activeObject={activeItem}
          setActiveObject={setActiveItem}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
